import { UmbracoTypes } from '~/lib/data-contract';
import { weakKey } from '~/shared/utils/jsx';
import { NodeItem } from '../NodeItem';
import { StyledList, StyledListItem } from './styled';

type NodeListProps = {
    nodes: UmbracoTypes.INavigationNode[];
    onSelectNode?: (node: UmbracoTypes.INavigationNode) => void;
};
export const NodeList = ({ nodes, onSelectNode }: NodeListProps) => (
    <StyledList>
        {nodes?.map((node) => (
            <StyledListItem key={weakKey(node)}>
                <NodeItem node={node} onSelectNode={onSelectNode} />
            </StyledListItem>
        ))}
    </StyledList>
);
